import {ReactModal} from '../../components/modals/ReactModal';
import {ReactReduxModalHOC} from '../react-redux-modals/components/ReactReduxModalHOC';
import {ReduxRequestModalEpics} from './epics';
import {buildReducer} from './reducers';
import {validateOptions} from './utils';

/**
 * Replaces the getState from both the request and modal.
 * Recommended to pass noop to pass initial validation.
 * @param {ReduxRequestModalOptions} options
 * @constructor
 */
export function ReduxRequestModal(options) {
  validateOptions(options);

  this.options = options;
  /** @type {ReduxRequestActions|ReactReduxModalActions} */
  this.actions = {
    ...options.reduxRequest.actions,
    ...options.reduxModal.actions,
  };
  this.reducers = buildReducer(options.reduxRequest, options.reduxModal, options);
  this.epics = new ReduxRequestModalEpics(options.reduxRequest, options.reduxModal, options);

  this.getRequestState = this.reducers.getRequestState;
  this.getModalState = this.reducers.getModalState;

  const modalConfig = {
    actions: this.actions,
    getState: this.reducers.getModalState,
    logger: options.logger,
  };

  /**
   * @param {Component|Function} modalComponent
   */
  this.setModal = modalComponent => {
    options.reduxModal.options.modalComponent = ReactReduxModalHOC(
      modalComponent,
      modalConfig,
      ReactModal,
    );
  };
}

/**
 * @typedef {Object} ReduxRequestModalOptions
 * @property {Function} getState Retrieve state from root state.
 * @property {ReduxRequest} reduxRequest
 * @property {ReactReduxModal} reduxModal
 * @property {String} [hideOnError=false]
 * @property {Logger} logger
 */



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-request-modal/index.js